<div class="label_sec">

    <div *ngIf="labelDetails?.status">
       Status : {{labelDetails?.status}}
    </div>

    <div *ngIf="labelDetails?.leadSource">
        Lead Source : {{labelDetails?.leadSource}}
    </div>
    <div *ngIf="commonService.ninetyDaysOld(labelDetails?.agreementEffectiveDate)">
        New Agreement
    </div>

    <div *ngIf="labelDetails?.agreementEffectiveDate">
        Days Active : {{commonService.daysActive(labelDetails?.agreementEffectiveDate)}}
    </div>

    <div *ngIf="labelDetails?.isComplainer">
        Complainer
    </div>

    <div *ngIf="labelDetails?.customerScore">
        Customer Score : {{labelDetails?.customerScore}}
    </div>

    <div *ngIf="commonService.renewPeriod(labelDetails?.agreementExpireDate)">
        Renewal Period
    </div>

    <div *ngIf="labelDetails?.pastDue > 0">
        Past Due : {{labelDetails?.pastDue | currency}}
    </div>
    <div *ngIf="labelDetails?.score">
       <mat-icon *ngIf="labelDetails?.score?.toLowerCase() === 'positive'" class="green_color thumb" matTooltip="Profit Gained" [matTooltipShowDelay]="300">thumb_up</mat-icon>
       <mat-icon *ngIf="labelDetails?.score?.toLowerCase() !== 'positive'" class="red_color thumb" matTooltip="Profit Loss" [matTooltipShowDelay]="300">thumb_down</mat-icon>
    </div>

</div>